(() => {
  if (customElements.get('educational-articles')) return;

  class EducationalArticles extends HTMLElement {
    constructor() {
      super();
      this.swiper = null;
      this.onSectionLoad = this.onSectionLoad.bind(this);
      this.onSectionUnload = this.onSectionUnload.bind(this);
    }

    connectedCallback() {
      this.initSwiper();
      document.addEventListener('shopify:section:load', this.onSectionLoad);
      document.addEventListener('shopify:section:unload', this.onSectionUnload);
    }

    disconnectedCallback() {
      this.destroySwiper();
      document.removeEventListener('shopify:section:load', this.onSectionLoad);
      document.removeEventListener('shopify:section:unload', this.onSectionUnload);
    }

    isOwnSection(event) {
      return !event.detail || event.detail.sectionId === this.dataset.sectionId;
    }

    onSectionLoad(event) {
      if (!this.isOwnSection(event)) return;
      this.destroySwiper();
      this.initSwiper();
    }

    onSectionUnload(event) {
      if (!this.isOwnSection(event)) return;
      this.destroySwiper();
    }

    initSwiper() {
      const swiperEl = this.querySelector('.educational-articles__swiper');
      if (!swiperEl || typeof Swiper === 'undefined') return;

      this.swiper = new Swiper(swiperEl, {
        slidesPerView: 1.225,
        spaceBetween: 16,
        slidesOffsetAfter: 20,
        watchOverflow: true,
        centerInsufficientSlides: true,
        grabCursor: true,
        on: {
          sliderFirstMove() {
            swiperEl.classList.add('educational-articles__swiper--dragging');
          },
          touchEnd() {
            swiperEl.classList.remove('educational-articles__swiper--dragging');
          },
        },
        pagination: {
          el: this.querySelector('.educational-articles__pagination'),
          clickable: true,
        },
        breakpoints: {
          768: {
            slidesPerView: 2,
            spaceBetween: 20,
            slidesOffsetAfter: 0,
          },
          1024: {
            slidesPerView: 3,
            spaceBetween: 20,
            slidesOffsetAfter: 0,
          },
        },
      });
    }

    destroySwiper() {
      if (this.swiper) {
        this.swiper.destroy(true, true);
        this.swiper = null;
      }
    }
  }

  customElements.define('educational-articles', EducationalArticles);
})();
